"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationAlias = exports.TapTypeApp = void 0;
const effect_1 = require("effect");
const NAMESPACE = 'Culligan.Device.Class.HydroTapBridge';
exports.TapTypeApp = effect_1.Schema.NonEmptyString.pipe(effect_1.Schema.maxLength(31)).annotations({
    identifier: `${NAMESPACE}.TapTypeApp`,
    description: 'Limited to 31 characters to fit the null-terminated buffer stored in device flash',
});
exports.LocationAlias = effect_1.Schema.NonEmptyString.pipe(effect_1.Schema.maxLength(31)).annotations({
    identifier: `${NAMESPACE}.LocationAlias`,
    description: 'Limited to 31 characters to fit the null-terminated buffer stored in device flash',
});
//# sourceMappingURL=common.js.map